import React from "react";
import './withdrawal.css';
import LayoutMain from "../../00LayoutMain/LayoutMain";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

    function TraderWithdrawalSourceGatsby (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="TraderWithdrawal">
                <div className="TraderWithdrawalIn">
                    <iframe
                        src={"https://my.fxbitcoin.org/iframe/funds/withdraw/?lang="+props.lang} name="deposit" title='FXbitcoinWithdrawal' className="autoHeight-iframe" frameBorder="0" width="100%" height="800"/>
                    </div>


            </main>
        </LayoutMain>

    )}

export default TraderWithdrawalSourceGatsby